import { html } from "lit-html";
import { LampEasySearchAction } from "../../../actions/lamp/lamp_search_action";
import { LampEasySearchJsEnv } from "../../../models/lamp/lamp_js_env";
import { CandidateWordSearchArea } from "./lamps";

const BASE_URL = window.location.protocol + '//' + window.location.host + '/';

export const LampEasySearchArea = (model: LampEasySearchJsEnv) => html`
<div class="o-menuBar_lamp">
<p class="o-menuBar_heading">ランプかんたん検索</p>
<div class="a-textinput js-input">
  <label class="a-textinput_label">
  <span
    class="a-textinput_labeltxt">型番
  </span>
    <span class="a-textinput_inputwrap">
    <input type="text" class="a-textinput_input" placeholder="例：FLR40SEXN" value=${(model.inputWord)}
      @keyup="${(event: Event) => {
        LampEasySearchAction.getLampModels(getValueFromEvent(event));
      }}"/>
    </span>
  </label>
</div>
${CandidateWordSearchArea(model)}
<button class="m-btn -auto-16 -small" type="button"
  .disabled="${model.selectedModel === ''}"
  @click="${() => { window.location.href = BASE_URL + createUrl(model.selectedModel) }}">
  <span class="m-btn_inner">
    <span class="m-btn_text">検索</span>
  </span>
</button>
</div>
`;

const createUrl = (selectedModel: string) => {
  return `ksearch/?refineKbn=2&refineCD1=${selectedModel}&callBackKbn=LAMP${window.location.pathname}`;
}

const getValueFromEvent = (event: Event): string => {
  const { target } = event;

  if (!(target instanceof HTMLInputElement)) {
    throw 'cannot get value from event.';
  }

  return target.value;
}
